import React from 'react';
import { Dot } from '@ygtechnologies/rubus-ui';
import { classnames } from '@ygtechnologies/bygr-frontend-component-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { Trans } from '@lingui/react/macro';

import theme from './RoomOptionTwoTierList.module.scss';
import { ProductThumbnails } from '@/seller/components/products/ProductThumbnails';
import { ConfiguratorGroupDto } from '@/services/configurator';
import { BuyerOptionCardPrice } from '../../../BuyerOptionCard/BuyerOptionCardPrice';
import { useImageUrls } from '../../../useImageUrls';
import { GroupQuantity } from './GroupQuantity';
import { groupQuantityUnit, groupSelectedOption } from './helpers';

interface GroupRowProps {
    group: ConfiguratorGroupDto;
    is3d: boolean;
    active?: boolean;
    onClick: () => void;
}

export const GroupRow: React.FC<GroupRowProps> = ({ group, is3d, active, onClick }) => {
    const { getProjectCatalogProductFileUrl, getProjectCatalogProductFileThumbnailUrl } = useImageUrls();
    const selectedOption = groupSelectedOption(group);
    const defaultOption = group.options.find((o) => o.isDefault) ?? null;
    const imageOption = selectedOption ?? defaultOption;
    const selected = !!selectedOption;

    return (
        <button
            type="button"
            className={classnames(theme.groupRow, { [theme.groupRowActive]: active })}
            onClick={onClick}>
            {!is3d && (
                <div className={theme.imageButton}>
                    <ProductThumbnails
                        imageUrlGenerator={getProjectCatalogProductFileUrl}
                        thumbnailUrlGenerator={getProjectCatalogProductFileThumbnailUrl}
                        images={imageOption?.product?.images || []}
                        hideImageCount
                        size={56}
                        className={theme.thumbnail}
                    />
                </div>
            )}
            <div className={theme.info}>
                <div className={theme.topLine}>
                    <span className={theme.name} title={group.name}>
                        {group.name}
                    </span>
                    <FontAwesomeIcon className={theme.chevron} icon={faChevronRight} />
                </div>
                <div className={theme.product} title={selectedOption?.productName ?? undefined}>
                    <span className={theme.productLabel}>
                        <Dot variant={selected ? 'primary' : 'warning'} />
                        {/* Quantity prefixes the product name, only once an option is selected. */}
                        {selected && (
                            <GroupQuantity quantity={group.quantity} unit={groupQuantityUnit(group)} plain />
                        )}
                        <span className={theme.productName}>
                            {selected ? selectedOption?.productName : <Trans>None selected</Trans>}
                        </span>
                    </span>
                </div>
                <div className={theme.price}>
                    {selectedOption && <BuyerOptionCardPrice option={selectedOption} compact />}
                </div>
            </div>
        </button>
    );
};
